/** Who pays MSC for this partner + setup fee / monthly subscription — shared by the Onboard wizard and Partner Billing. */
import React from 'react';
import { inputCls } from '../finance/financeUi';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const WHO_PAYS = {
  USER_PAYS: 'Partner pays',
  MSC_COMPED: 'Comped by MSC',
  UPLINE_PAYS: 'Paid by upline',
  NO_BILLING_REQUIRED: 'No billing required',
};

export function WhoPaysFields({ value, onChange, testid = 'who-pays' }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const pays = value.billing_responsibility === 'USER_PAYS';
  return (
    <div className="grid gap-2 sm:grid-cols-3" data-testid={testid}>
      <label className="text-xs">Who pays
        <Select value={value.billing_responsibility} onValueChange={(v) => onChange({ ...value, billing_responsibility: v })}>
          <SelectTrigger className="h-10" data-testid={`${testid}-select`}><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(WHO_PAYS).map(([k, l]) => <SelectItem key={k} value={k} data-testid={`${testid}-opt-${k}`}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </label>
      <label className="text-xs">Setup fee $<input className={inputCls} type="number" min="0" disabled={!pays} value={value.setup_fee} onChange={set('setup_fee')} data-testid={`${testid}-setup-fee`} /></label>
      <label className="text-xs">Monthly subscription $<input className={inputCls} type="number" min="0" disabled={!pays} value={value.monthly_fee} onChange={set('monthly_fee')} data-testid={`${testid}-monthly-fee`} /></label>
      <p className="text-xs text-muted-foreground sm:col-span-3">{pays ? 'Activation finishes once the setup fee and first month are paid.' : 'This partner owes MSC nothing — the billing step is marked done automatically.'}</p>
    </div>
  );
}
